import moment from 'moment'
import { Dialog } from 'primereact/dialog'
import React from 'react'
import { NOTIFICATION_MESSAGE_TYPE } from '../../constants'
import MESSAGES from '../../constants/Messages'
import { sendEmailForAssistance } from '../../utils/ExceptionHandlingUtil'
import { useTranslation,Trans} from 'react-i18next'
import { CustomPopup } from '../../common/Popup/CustomPopup'
const AviShippingItemValidationPopUp = ({
	displayShippingItemPopup,
	setDisplayShippingItemPopup,
	handleClear,
	selectedDestination,
	selectedOrigin,
	shippingDate,
	shippingItem,
	setIsLoading,
	setNotificationMessage,
	setNotificationType,
	setShippingItem,
	additionalSccs,
}) => {
	const { t } = useTranslation(['labels', 'errors'])

	const handleCancel = () => {
		setDisplayShippingItemPopup(false)
		setShippingItem(null)
	}

	const handleConfirm = async () => {
		const attributes = [
			{
				key: 'origin',
				value: selectedOrigin ? selectedOrigin.code : null,
			},
			{
				key: 'destination',
				value: selectedDestination ? selectedDestination.code : null,
			},
			{
				key: 'shippingItem',
				value: shippingItem &&
					shippingItem?.description &&
					shippingItem?.product
					? `${shippingItem?.description}-${shippingItem?.product}`
					: null,
			},
			{
				key: 'shippingDate',
				value: shippingDate ? moment(shippingDate).format('DD MMM YYYY') : null,
			},
			{
				key: 'sccs',
				value: getSccs(additionalSccs),
			},
			{
				key: 'enquiryReason',
				value: t('COMMON.SHIPPING_ITEM_ENQUIRY', { description: shippingItem?.description }),
			},
		]
		const replacements = {
			'%DESCRIPTION%': shippingItem ? shippingItem?.description : '',
			'%PRODUCT%': shippingItem ? shippingItem?.product : '',
		}

		const response = await sendEmailForAssistance(
			'SHIPPING_ITEM',
			setIsLoading,
			attributes,
			replacements
		)
		setDisplayShippingItemPopup(false)

		if (response) {
			setNotificationMessage(t(MESSAGES.ASSISTANCE_MSG, { ns: 'errors' }))
			setNotificationType(NOTIFICATION_MESSAGE_TYPE.INFO)
		} else {
			setIsLoading(false)
			setNotificationMessage(
				t(MESSAGES.MAIL_ASSISTANCE_FAILS, { ns: 'errors' })
			)
			setNotificationType(NOTIFICATION_MESSAGE_TYPE.ERROR)
		}
		window.scrollTo(0, 0)
		handleClear()
	}

	const getSccs = (additionalSccs) => {
		if (additionalSccs && additionalSccs.length) {
			return additionalSccs.map((e) => e.scc).toString()
		} else {
			return null
		}
	}

	const RenderFooter = () => {
		return (
			<div>
				<button icon='' className='primary-button' onClick={handleCancel} >
					{t('COMMON.GO_BACK')}
				</button>
				<button icon='' className='secondary-button' onClick={handleConfirm}>
					{t('COMMON.SEND_ENQUIRY')}
				</button>
			</div>
		)
	}

	return (

		<CustomPopup
			isVisible={displayShippingItemPopup}
			headerComponent={{ mainHeader: t('BOOKING.ASSISTANCE_HEAD') }}
			footerPriBtnLabel={t('COMMON.OK')}
			footerPriBtnClick={handleConfirm}
			footerSecBtnLabel={t('COMMON.CANCEL')}
			footerSecBtnClick={handleCancel}
			onClose={handleCancel}
			body={
				shippingItem?.description === "Live Animals" ? (
				  <>
					<p>
						{t('BOOKING.AVI_ASSISTANCE_HEAD')}
						<br/>
					
						<Trans
                                                i18nKey="ER254"
                                                ns="errors"
                                                  values={{ item: shippingItem?.description }}
                                                  components={[<strong key="0" />]}
                                                  />
					  <br />
					  {t(MESSAGES.AVI_ASSISTANCE_MSG_SHIPPING_LABEL2, {
						item: '',
						ns: 'errors',
					  })}
					</p>
				  </>
				) : (
				  <p>
					<strong>{shippingItem?.description}</strong>
					{t(MESSAGES.ASSISTANCE_MSG_SHIPPING, {
					  item: shippingItem?.description,
					  ns: 'errors',
					})}
				  </p>
				)
			  }
			/>
	)
}

export default AviShippingItemValidationPopUp
